import React, { useState } from "react";
import Helmet from "react-helmet";
import { connect } from "react-redux";
import { useHistory, Link } from "react-router-dom";
import { Field, reduxForm } from "redux-form";
import LoadingButton from "components/shared/LoadingButton";
import { LOGIN } from "helpers/viewContent";
import { MAIN_LOGO } from "utils/constant";
import { login } from "store/services/authService";
//imported
import { dashboard, forgot_password } from "routes/paths";
const renderField = ({
  input,
  placeholder,
  type,
  autoComplete,
  meta: { touched, error, warning },
}) => (
  <>
    <input
      {...input}
      type={type}
      placeholder={placeholder}
      autoComplete={autoComplete}
      className={`form-control ${touched && error ? `is-invalid` : ""}`}
    />

    {touched && error && <span className="invalid-feedback">{error}</span>}
  </>
);

const Login = (props) => {
  const history = useHistory();
  const [sending, setSending] = useState(false);
  const { handleSubmit, submitting } = props;

  const [values, setValues] = useState({
    email: "",
    password: "",
  });

  const handleSubmit_ = async (values) => {
    try {
      setSending(true);
      await props.dispatch(login(values)).then((res) => {
        setSending(false);
        if (res.data?.success) {
          history.push(dashboard);
        }
      });
    } catch (err) {
      console.log(err);
      setSending(false);
    }
  };

  return (
    <>
      <Helmet title={LOGIN.CURRENT_MODULE} />
      <div className="container-fluid page-body-wrapper full-page-wrapper">
        <div className="content-wrapper px-0 d-flex align-items-center auth">
          <div className="row flex-grow">
            <div className="col-lg-6 mx-auto">
              <div className="auth-form-light text-left rounded p-lg-5 p-3">
                <div className="brand-logo">
                  <img src={MAIN_LOGO} className="loginLogo img-fluid" />
                </div>
                <div className="authHeader py-2">
                  <h4 className="fw-bold themeClr">Hello! let's get started</h4>
                  <h6 className="font-weight-light text-muted">Sign in to continue.</h6>
                </div>
                <form className="pt-3" onSubmit={handleSubmit(handleSubmit_)} autoComplete="off">
                  <div className="form-group">
                    <Field
                      name="email"
                      component={renderField}
                      placeholder="E-Mail*"
                      type="email"
                      autoComplete="off"
                    />
                  </div>
                  <div className="form-group">
                    <Field
                      name="password"
                      component={renderField}
                      placeholder="Password*"
                      type="password"
                      autoComplete="new-password"
                    />
                  </div>
                  <div className="mt-3">
                    <LoadingButton
                      type="submit"
                      className="btn btn-block btn-gradient-primary btn-lg font-weight-medium auth-form-btn col-md-12"
                      loading={sending}
                      disabled={submitting}
                    >
                      {!sending ? "SIGN IN" : "Loading..."}
                    </LoadingButton>
                  </div>
                  <div className="my-2 d-flex justify-content-between align-items-center">
                    <div className="form-check"></div>
                    <Link to={forgot_password} className="auth-link fw-sbold themeClr">
                      Forgot password?
                    </Link>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

const validate = (values) => {
  const errors = {};
  //email
  if (!values.email) {
    errors.email = "Email Required";
  } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)) {
    errors.email = "Invalid email address";
  }
  //password
  if (!values.password) {
    errors.password = "Password Required";
  } else if (values.password.length < 6) {
    errors.password = "Must be 6 characters or greater";
  }
  return errors;
};

const mapStateToProps = (state) => {
  return {
    isAuthenticated: state.Auth.isAuthenticated,
    user: state.Auth,
  };
};

function mapDispatchToProps(dispatch) {
  return { dispatch };
}

const LoginForm = reduxForm({
  form: "login",
  validate,
})(Login);

export default connect(mapStateToProps, mapDispatchToProps)(LoginForm);
